import { BenefitsTableRow } from './BenefitsTableRow';
import { QuoteCoverageTableHeadings, QuoteCoverageTableContent } from './BenefitsTable.types';

const styles = {
  table:
    'grid grid-cols-12 mb-space-400 gap-x-space-200 max-w-[1000px] mx-auto outline-3 outline-(--color-neutral-200) rounded rounded(--border-radius)',
  tableHead:
    'col-start-1 p-space-500 col-span-12 grid grid-cols-12 text-center border-b border-b-3 border-(--color-neutral-200) ',
};

export const BenefitsTable = ({
  headings,
  content,
}: {
  headings: QuoteCoverageTableHeadings[];
  content: QuoteCoverageTableContent[];
}) => (
  <table className={styles.table}>
    <thead className={styles.tableHead}>
      <tr className="col-span-12  grid grid-cols-12">
        {headings.map((header, index) => (
          <th
            className={`col-span-5 md:col-span-4 text-center flex flex-col items-center gap-x-space-200 ${header.type === 'extra' ? 'col-start-8 justify-self-center md:col-start-10 text-success-600' : 'col-start-0 md:col-start-6 justify-self-end'}`}
            key={index}
          >
            <p className="mr-space-300 mb-space-100 text-body-large-strong">{header.heading}</p>
            <p className="text-body-small">{header.description}</p>
          </th>
        ))}
      </tr>
    </thead>

    <tbody className="col-span-12">
      {content.map((coverage, index) => (
        <BenefitsTableRow key={index} coverage={coverage} />
      ))}
    </tbody>
  </table>
);
